import { Link } from "react-router-dom";
import ChatbotImg from "../../images/chat-bot.svg";

const LoginScreen = ({ children }) => {
    return(
        <div id="login-screen" className="d-flex">
            <div className="overlay flex-grow-1"></div>
            <div className="login-wrapper tif-py-sm-55 tif-py-25 tif-px-sm-60 tif-px-30 tif-color-white overflow-auto">
                <div className="header d-flex justify-content-between tif-mb-sm-140 tif-mb-70">
                <Link to="/"><img src={ ChatbotImg } alt="Gelest AI chatbot logo" /></Link>
                <p className="text-uppercase tif-ls-25 tif-mt-10 tif-mb-0">Owner Dashboard</p>
                </div>

                { children }
            </div>
        </div>
    );
};

export default LoginScreen;